import { fetchEntity, createEntityWithDefaults } from "actions/entities";
import React from 'react'
import { connect } from 'react-redux'
import pluralize from "pluralize";
import { actions } from "react-redux-form"

import { getUiOptions } from 'selectors/forms'
import SelectorFieldControl from "./SelectorFieldControl";
import {
  getEntitiesForSelector,
  getEntityIdFromState,
  getEntityModel,
  mapEntitiesToSelectableOptions,
  selectableOptionsToTranslated,
  withBlankOption
} from "./selectorFieldOptions";

const SemanticSelectorField = (props) => {
  return <SelectorFieldControl searchable {...props}/>
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const entityModel = getEntityModel(ownProps)
  const options = ownProps.uiSchema?.["ui:options"] || {}
  const entityName = options.entityName
  const entitiesName = pluralize.plural(entityName)
  const fetchEntityAfterSelect = options.fetchEntityAfterSelect

  return {
    handleChange: (event, dropdownProps) => {
      if (options.onSelect) dispatch(options.onSelect(dropdownProps.value))
      dispatch(actions.change(entityModel, dropdownProps.value))
      if (fetchEntityAfterSelect) {
        dispatch(fetchEntity(entitiesName, dropdownProps.value))
      }
    },
    createEntityWithDefaults: () => {
      dispatch(createEntityWithDefaults(entityName))
    }
  }
}

const mapStateToProps = (state, ownProps) => {
  const options = getUiOptions(state, ownProps) || {}
  const {
    entityName,
    displayAttribute,
    valueAttribute,
    includeBlank,
    EntityForm,
    selector,
    selectableOptions
  } = options

  let entityId = getEntityIdFromState(state, ownProps)
  let optionsToDisplay = []

  if (selectableOptions) {
    entityId = String(entityId)
    optionsToDisplay = selectableOptionsToTranslated(selectableOptions, entityName)
  } else {
    const entities = getEntitiesForSelector(state, ownProps, { selector, entityName })
    optionsToDisplay = entities.map(mapEntitiesToSelectableOptions(displayAttribute, valueAttribute))
  }

  return {
    entityId,
    entityName,
    selectOptions: withBlankOption(optionsToDisplay, includeBlank, ownProps.translationScope),
    EntityForm
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(SemanticSelectorField);
